/*
  CDS — Média secondaire au survol des cartes produit.
  Utilisé par : CDS — Collection (grille), Produits à onglets, Collection (grid), Recherche, Favoris.
  Délégation d'événements sur document => fonctionne aussi après changement d'onglet / re-render.

  Carte : [data-cds-hover-card]
  Couche image (2e image du produit) : img[data-cds-hover-img]
  Couche vidéo : video[data-cds-hover-video]

  Règle d'affichage (le CSS de chaque section décide de la couche visible) :
  - souris + animations autorisées : la vidéo passe devant la 2e image ;
  - tactile (téléphone, tablette) ou « réduire les animations » : 2e image uniquement ;
  - la vidéo ne démarre pas (bloquée, interrompue, trop lente) : la 2e image prend le relais,
    jamais de miniature figée.
    .cds-hover--no-video : lecture impossible sur cet appareil (définitif pour la carte)
    .cds-hover--fallback : repli temporaire (appui tactile, ou vidéo pas encore lancée)
*/
(function () {
  if (window.__cdsHoverMedia) return;
  window.__cdsHoverMedia = true;

  var STALL_MS = 1500;
  var mqVideo = window.matchMedia
    ? window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)')
    : null;

  function videoAllowed() {
    return !!(mqVideo && mqVideo.matches);
  }

  function cardFrom(target) {
    return target && target.closest ? target.closest('[data-cds-hover-card]') : null;
  }

  function isHovered(card) {
    try { return card.matches(':hover'); } catch (e) { return true; }
  }

  /* Chargement paresseux : rien n'est téléchargé avant la première interaction avec la carte.
     Sans ça, chaque carte téléchargeait plusieurs Mo au chargement de la page. */
  function loadImage(card) {
    var img = card.querySelector('img[data-cds-hover-img]');
    if (!img || img.dataset.cdsLoaded) return;
    if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
    if (img.dataset.src) img.setAttribute('src', img.dataset.src);
    img.dataset.cdsLoaded = '1';
  }

  function loadVideo(v) {
    if (v.dataset.cdsLoaded) return;
    // Miniature de la vidéo : appliquée seulement ici (jamais téléchargée sur mobile).
    if (v.dataset.poster) v.setAttribute('poster', v.dataset.poster);
    var sources = v.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
      sources[i].removeAttribute('data-src');
    }
    v.dataset.cdsLoaded = '1';
    if (sources.length) {
      try { v.load(); } catch (e) {}
    }
  }

  function clearStall(card) {
    if (card.__cdsStall) {
      clearTimeout(card.__cdsStall);
      card.__cdsStall = null;
    }
  }

  /* Garde-fou : si la vidéo ne joue toujours pas après STALL_MS, on montre la 2e image. */
  function armStall(card, v) {
    clearStall(card);
    card.__cdsStall = setTimeout(function () {
      card.__cdsStall = null;
      if ((v.paused || v.readyState < 3) && isHovered(card)) card.classList.add('cds-hover--fallback');
    }, STALL_MS);
  }

  function watchVideo(card, v) {
    if (v.dataset.cdsWatched) return;
    v.dataset.cdsWatched = '1';
    // La vidéo joue vraiment : elle reprend sa place devant la 2e image.
    v.addEventListener('playing', function () {
      clearStall(card);
      card.classList.remove('cds-hover--fallback');
    });
    // Échec de chargement : seule l'erreur de la dernière source compte (le navigateur essaie les suivantes).
    v.addEventListener('error', function (e) {
      var sources = v.querySelectorAll('source');
      if (e.target === v || e.target === sources[sources.length - 1]) {
        clearStall(card);
        card.classList.add('cds-hover--no-video');
      }
    }, true);
  }

  function playVideo(card, v) {
    try {
      var p = v.play();
      if (p && p.catch) {
        p.catch(function (err) {
          if (err && err.name === 'AbortError') {
            // Interrompue (souris ressortie, économie d'énergie…) : si la carte est encore survolée,
            // on évite la miniature figée en passant sur la 2e image.
            if (isHovered(card)) card.classList.add('cds-hover--fallback');
            return;
          }
          // NotAllowedError (lecture auto bloquée), NotSupportedError (aucune source lisible)…
          clearStall(card);
          card.classList.add('cds-hover--no-video');
        });
      }
    } catch (err) {
      card.classList.add('cds-hover--no-video');
    }
  }

  function onEnter(e) {
    var card = cardFrom(e.target);
    if (!card) return;
    loadImage(card);

    // Appui au doigt ou au stylet : jamais de vidéo, la 2e image suffit.
    if (e.pointerType && e.pointerType !== 'mouse') {
      card.classList.add('cds-hover--fallback');
      return;
    }

    if (!videoAllowed() || card.classList.contains('cds-hover--no-video')) return;
    var v = card.querySelector('video[data-cds-hover-video]');
    if (!v) return;
    // Entrée réelle dans la carte, ou premier événement vu par le script (chargé en différé,
    // la souris peut déjà être sur la carte) : on (re)prépare la vidéo avant de la lancer.
    var entering = !(e.relatedTarget && card.contains(e.relatedTarget));
    if (entering || !v.dataset.cdsLoaded) {
      card.classList.remove('cds-hover--fallback');
      loadVideo(v);
      watchVideo(card, v);
      armStall(card, v);
    }
    if (v.paused) playVideo(card, v);
  }

  function onLeave(e) {
    var card = cardFrom(e.target);
    if (!card) return;
    // On ne coupe que si le pointeur quitte réellement la carte (pas un déplacement interne).
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    clearStall(card);
    if (e.pointerType === 'mouse' || !e.pointerType) card.classList.remove('cds-hover--fallback');
    var v = card.querySelector('video[data-cds-hover-video]');
    if (!v) return;
    try {
      v.pause();
      v.currentTime = 0;
    } catch (err) {}
  }

  var hasPointer = 'PointerEvent' in window;
  document.addEventListener(hasPointer ? 'pointerover' : 'mouseover', onEnter, false);
  document.addEventListener(hasPointer ? 'pointerout' : 'mouseout', onLeave, false);

  // Tactile : charge la 2e image dès le contact, avant que le survol « collant » ne l'affiche.
  document.addEventListener('touchstart', function (e) {
    var card = cardFrom(e.target);
    if (card) {
      card.classList.add('cds-hover--fallback');
      loadImage(card);
    }
  }, { passive: true });
})();
